export interface NormalizedError {
  status?: number
  message: string
  data?: unknown
}

function readStatus(error: any): number | undefined {
  const status = error?.response?.status ?? error?.status ?? error?.statusCode
  return typeof status === 'number' ? status : undefined
}

function readData(error: any): unknown {
  return error?.response?._data ?? error?.response?.data ?? error?.data
}

export function normalizeError(error: unknown, fallbackMessage = 'Error desconocido'): NormalizedError {
  const status = readStatus(error)
  const data = readData(error)
  const message =
    (typeof data === 'object' && data && 'message' in data && typeof (data as any).message === 'string' && (data as any).message) ||
    (error instanceof Error && error.message) ||
    (typeof (error as any)?.message === 'string' && (error as any).message) ||
    fallbackMessage

  return {
    status,
    message,
    data,
  }
}

export function getErrorMessage(error: unknown, fallbackMessage = 'Error desconocido'): string {
  return normalizeError(error, fallbackMessage).message
}

export function logError(context: string, error: unknown, extra?: Record<string, unknown>) {
  const normalized = normalizeError(error)

  console.error(context, {
    message: normalized.message,
    status: normalized.status,
    ...(normalized.data !== undefined ? { data: normalized.data } : {}),
    ...(extra || {}),
  })
}
